// @ts-nocheck
import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow'; 
import bookingView from '../../images/bookingView.svg';
import bookingSlashView from '../../images/bookingSlashView.svg';
import bookingfileSlashView from '../../images/bookingfileSlashView.svg';
import lodashfilter from 'lodash/filter';
import uniq from 'lodash/uniq';
import * as Autosuggest from 'react-autosuggest';
var Config: any = require('../../Config.json');

var methodResult = true;
var selReefers;
var lastCheckedNodes = [];
var lastCheckedParentNode = "";
var selectedReefers = "";
var selectedUnits = "";
var IsTriggered = false;
var self;

export interface BookingSystemState {
    SelectedReefers: any[];
    BookingSystem: server.BookingSystem_UIModel;
    RefTemperatureUnit: server.RefTemperatureUnit[];
    isLoading: boolean;
    collapsed: boolean;
    checked: any;
    expanded: any;
    CustomerGroups: Customers[];   
    CustomerGroupsList: Customers[];   
    IsCustomerAccessHide: boolean;
    UnassignOption: string;
    lbl3rdPartyDisabled: boolean;
    lblBookingDisabled: boolean;
    lblBothDisabled: boolean;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    RefVessels: server.vesselsList[];
    suggestionsVesselId: any[],
    suggestionsVoyage: any[],
    suggestionsCalls: any[],
    ArrsuggestionsVesselId: any[],
    ArrsuggestionsVoyage: any[],
    ArrsuggestionsCalls: any[],
    UnassignOptionMode: string;
}
var newBookingSystem: server.BookingSystem_UIModel = {
    BookedTemperature: '', BookedTemperatureUnit: '', BookingNumber: '', CustomerId: 0, eventmasteridForAssign: 0,
    eventmasteridforupdate: 0, RcdmasterId: 0, reeferID: '', Unitmasterid: 0, UserId: 0,
    RCDReportingInterval: '', SetPoint: '', EventDtm: '', SelectedUnits: [], Groups: [], IsEdit: false, UnassignMode: '', IsBookingModified: false, IsCustomerAccessModified: false,
    IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0,
    OperationalLevel: 'SelectedReefer', BookingInfo: []
};
export class NewBookingUnAssign extends React.Component<any, BookingSystemState> {    
    constructor(props: any) {
        super(props);
        this.state = {
            SelectedReefers: [], BookingSystem: newBookingSystem, RefTemperatureUnit: [], isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [], IsCustomerAccessHide: true, UnassignOption: '', lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, IsCommandIssued: false, PrevSelectedItems: []
            , RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: [],UnassignOptionMode:''         };
        lastCheckedNodes = [];
        selReefers = this.props.reeferData;
    }

    getRefTemperatureUnit() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetRefTemperatureUnit')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTemperatureUnit[]>)
            .then(data => {
                this.setState({ RefTemperatureUnit: data });
            });
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        var EventMasterList = this.props.reeferFormatter.EventMasterList;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
                var EventCd = eventDescription[0].EventCd;
            }
            var IsAssignTo3P;
            if (reeferData != null && reeferData != undefined) {
                
                if (reeferData[0].CustomerName != "" && reeferData[0].BookingNumber == null && reeferData[0].BookingNumber == '') {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
                else if (reeferData[0].BookingNumber == null){
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
            }
            this.setState({ SelectedReefers: reeferData }, () => { this.bindUnassignData(this.props.CustomerAccessData,EventCd,IsAssignTo3P); });
            this.getRefTemperatureUnit();
            var TemperatureUnitCd = "";
            var unassignMode = "";            
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData)) {
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var BookedTemperature = parseFloat(_lststrValue[0]);
                    var temperatureCd = _lststrValue[1];
                }
                if (temperatureCd == "F")
                    TemperatureUnitCd = "Fahrenheit";
                else if (temperatureCd == "C")
                    TemperatureUnitCd = "Celsius";

                bookingSystem.BookedTemperatureUnit = TemperatureUnitCd;
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = BookedTemperature != undefined ? BookedTemperature.toString() : '';              
            }    
            this.setState({ BookingSystem: bookingSystem });
        }
    }    

    onExpand(expanded) {
        this.setState({ expanded: expanded });
    }

    submitUnAssignCommand() {
        $('#globalLoader').show();
        this.state.BookingSystem.RcdmasterId = this.state.SelectedReefers[0].RCDMasterID;
        this.state.BookingSystem.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        this.state.BookingSystem.CustomerId = this.state.SelectedReefers[0].CustomerID;
        this.state.BookingSystem.UserId = this.props.UserID;
        this.state.BookingSystem.eventmasteridForAssign = 0;
        this.state.BookingSystem.eventmasteridforupdate = 0;
        this.state.BookingSystem.EventDtm = this.state.SelectedReefers[0].EventDTTM;
        this.state.BookingSystem.RCDReportingInterval = this.state.SelectedReefers[0].RCDReportingInterval;
        this.state.BookingSystem.SetPoint = this.state.SelectedReefers[0].SetPoint;

        var checkedGroupIds = [];
        var selUnits = [];
        var checkedList = this.state.checked;

        if (this.state.SelectedReefers.length > 1) {
            $.each(this.state.SelectedReefers, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = this.state.SelectedReefers[0].UnitMasterID.toString();
        }

        $.each(selectedUnits.split(','), function (index, value) {
            selUnits.push(parseInt(value));
        });

        $.each(checkedList, function (index, value) {            
            checkedGroupIds.push(parseInt(value.split(':')[1].split('_')[0]));
        });

        this.state.BookingSystem.SelectedUnits = selUnits;
        this.state.BookingSystem.Groups = checkedGroupIds;
        this.state.BookingSystem.UnassignMode = this.state.UnassignOption;
        var reefersCount = this.state.SelectedReefers.length; // RCNG 361
        var bookingSystem = JSON.stringify(this.state.BookingSystem);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/UnAssignBookingdetails';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: bookingSystem, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                if (data == 'Reefer unassigned successfully.') {                    
                    $("#contextMenuModel .btn-close").click(); 
                    if (this.state.BookingSystem.UnassignMode == "UnassignBooking")
                        data = (reefersCount == 1) ? 'Reefer unassigned from Booking successfully.': reefersCount + ' Reefers unassigned from Booking successfully.';
                    if (this.state.BookingSystem.UnassignMode == "Unassign3rdParty")
                        data = (reefersCount == 1) ? 'Reefer unassigned from Customer Access successfully.': reefersCount + ' Reefers unassigned from Customer Access successfully.';
                    if (this.state.BookingSystem.UnassignMode == "UnassignBoth")
                        data = (reefersCount == 1) ? 'Reefer unassigned from both Booking and Customer Access successfully.': reefersCount + ' Reefers unassigned from both Booking and Customer Access successfully.';
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();
                    PopupWindow.showErrorMessage("Booking and Access", data);
                    
                }
                else {
                    PopupWindow.showErrorMessage("Booking and Access", data);
                }
            });

    }

    bindUnassignData(customerAccessData: any, EventCd: string, IsAssignTo3P:boolean) {
        if (customerAccessData != undefined) {
            this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customerAccessData)), CustomerGroupsList: customerAccessData });
            if (customerAccessData.length > 0) {
                var defaultChecked = [];
                var defaultExpand = [];
                $.each(customerAccessData, function (index, value) {
                    if (value.isSelected == true) {
                        defaultExpand.push(value.value);
                    }
                    $.each(value.children, function (ind, val) {
                        if (val.isSelected == true) {
                            defaultChecked.push(val.value);
                        }
                    });
                });
                this.setState({ isLoading: false, IsCustomerAccessHide: false, checked: defaultChecked, expanded: defaultExpand }, () => { return lastCheckedNodes = this.state.checked, this.updateUnassginModel(EventCd, IsAssignTo3P) });

            }
            else {
                lastCheckedNodes = [];
                this.setState({ isLoading: false, checked: [], expanded: [], CustomerGroups: [], CustomerGroupsList: [], IsCustomerAccessHide: true }, () => this.updateUnassginModel(EventCd, IsAssignTo3P));
            }
        }
    }

    componentWillReceiveProps(nextprops: any) {     
        var reeferData = nextprops.reeferData;  
        var EventMasterList = nextprops.reeferFormatter.EventMasterList;

        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
               var EventCd = eventDescription[0].EventCd;
            }
            var IsAssignTo3P;
            if (reeferData != null && reeferData != undefined) {
                
                if (reeferData[0].CustomerName != "" && reeferData[0].BookingNumber == null && reeferData[0].BookingNumber == '') {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
                else if (reeferData[0].BookingNumber == null) {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
            }

            this.setState({ SelectedReefers: reeferData }, () => { this.bindUnassignData(nextprops.CustomerAccessData, EventCd, IsAssignTo3P); });
            this.getRefTemperatureUnit();
            var TemperatureUnitCd = "";
            var unassignMode = "";    
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(newBookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData)) {
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var BookedTemperature = parseFloat(_lststrValue[0]);
                    var temperatureCd = _lststrValue[1];
                }
                if (temperatureCd == "F")
                    TemperatureUnitCd = "Fahrenheit";
                else if (temperatureCd == "C")
                    TemperatureUnitCd = "Celsius";
                bookingSystem.BookedTemperatureUnit = TemperatureUnitCd;
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = BookedTemperature != undefined ? BookedTemperature.toString() : '';
            }

            this.setState({ BookingSystem: bookingSystem });      
        }        
    }


    CloseModal() {
        lastCheckedNodes = [];
        this.setState({ checked: lastCheckedNodes });
    } 

    updateUnassginModel(EventCd: string, IsAssignTo3P: boolean) {
        
        if (EventCd === "BDR" || IsAssignTo3P) {
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: true, lblBothDisabled: true, UnassignOption: "Unassign3rdParty",UnassignOptionMode:"Unassign3rdParty" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        }
        else if (this.state.SelectedReefers[0].BookingNumber != null && this.state.SelectedReefers[0].BookingNumber != '' && !this.ValidateBookingID(this.state.SelectedReefers) && this.state.checked.length > 0)
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, UnassignOption: "UnassignBoth" ,UnassignOptionMode:"UnassignBoth"},
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        else if (this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '' && !this.ValidateBookingID(this.state.SelectedReefers))
            this.setState({ lbl3rdPartyDisabled: true, lblBookingDisabled: false, lblBothDisabled: true, UnassignOption: "UnassignBooking",UnassignOptionMode:"UnassignBooking" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        else
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: true, lblBothDisabled: true, UnassignOption: "Unassign3rdParty",UnassignOptionMode:"Unassign3rdParty" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
    }

    UnassignModeChange(value) {       
        //if (!this.state.lbl3rdPartyDisabled && this.state.lblBookingDisabled && this.state.lblBothDisabled) {
        //    if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
        //    if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');
        //    if (!$("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').addClass('active');
        //}
        //if (!this.state.lblBookingDisabled && this.state.lbl3rdPartyDisabled && this.state.lblBothDisabled) {
        //    if (!$("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').addClass('active');
        //    if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');
        //    if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
        //}

        //if (value == "UnassignBooking" && !this.state.lblBookingDisabled) {
        //    if (!$("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').addClass('active');          
        //    if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
        //    if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');            
        //    this.setState({ UnassignOption: value });
        //}
        //if (value == "Unassign3rdParty" && !this.state.lbl3rdPartyDisabled) {
        //    if (!$("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').addClass('active');
        //    if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
        //    if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');                       
        //    this.setState({ UnassignOption: value });
        //}
        //if (value == "UnassignBoth" && !this.state.lblBothDisabled) {
        //    if (!$("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').addClass('active');
        //    if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
        //    if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
        //    this.setState({ UnassignOption: value });
        //}        
        this.setState({ UnassignOption: value });
    } 

    ValidateBookingID(reeferData: any) {
        if (reeferData.length > 0 && reeferData[0].LastBookingEventMasterId != null && reeferData[0].LastBookingEventMasterId.length > 0) {
            for (var lastBookingID in reeferData[0].LastBookingEventMasterId) {
                if (reeferData[0].EventMasterID == parseInt(reeferData[0].LastBookingEventMasterId[lastBookingID])) {
                    return true;
                }
            }
        }
        return false;
    }

    public render() {
        var cssBooking: any;
        var css3rdParty: any;
        var cssBoth: any;
        if (this.state.UnassignOptionMode == "UnassignBooking") {
            css3rdParty = true;
            cssBoth = true;
            cssBooking = false;
        }
        else if (this.state.UnassignOptionMode == "Unassign3rdParty") {
            cssBoth = true;
            cssBooking = true;
            css3rdParty = false;
        }
        else if (this.state.UnassignOptionMode == "UnassignBoth") {
            cssBoth = false;
            cssBooking = false;
            css3rdParty = false;
        }
        const { checked, expanded } = this.state;
        return <div>
            <div id="UnAssignBookingDiv" hidden={this.state.isLoading}>
                <div className='well'>
                    <div className="row" >
                        <div className="col-lg-4 col-md-4 text-sm-end pe-0" >
                            <span className='col-form-label'>Reefer ID:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.reeferID : ''}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2" >
                        <div className="col-lg-4 col-md-4 text-sm-end pe-0" >
                            <span className='col-form-label'>Booking #:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.BookingNumber : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div id="CustomerAccessDiv" hidden={this.state.IsCustomerAccessHide}>
                    <div className="card text-bg-light mt-3">
                        <div className="card-header"> Customer Access </div>
                        <div className="card-body custom-treeview max-height-15rem">
                            {this.state.CustomerGroups.length > 0 ? <CheckboxTree
                                checked={checked}
                                expanded={expanded}
                                nodes={this.state.CustomerGroups}
                                showNodeIcon={false}
                                disabled={true}
                            /> : null}
                        </div>
                    </div>

                    <div className="list-group BookingListgroup">
                        <label className="list-group-item">
                            <input className="form-radio-input" onChange={(e) => this.UnassignModeChange('UnassignBooking')} type="radio" disabled={cssBooking} value="UnassignBooking" checked={this.state.UnassignOption == 'UnassignBooking'} />
                            <img src={bookingView} className='' alt='bookingView' />
                            <span>Unassign reefers from bookings. Do not revoke any third-party authorization.</span>
                            <div> {/*<img src={booking1sticon} alt='delete' /> */}</div>
                        </label>
                        <label className="list-group-item">
                            <input className="form-radio-input" onChange={(e) => this.UnassignModeChange('Unassign3rdParty')} type="radio" disabled={css3rdParty}value="Unassign3rdParty" checked={this.state.UnassignOption == 'Unassign3rdParty'} />
                            <img src={bookingSlashView} className='' alt='bookingSlashView' />
                            <span>Revoke any and all third-party authorizations. Do not unassign reefers from bookings.</span>
                        </label>
                        <label className="list-group-item">
                            <input className="form-radio-input" onChange={(e) => this.UnassignModeChange('UnassignBoth')} type="radio" disabled={cssBoth} value="UnassignBoth" checked={this.state.UnassignOption == 'UnassignBoth'} />
                            <img src={bookingfileSlashView} className='' alt='bookingfileSlashView' />
                            <span>Unassign reefers from bookings. Revoke any and all third-party authorizations. </span>
                        </label>
                    </div>
                    
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.CloseModal.bind(this)}>Cancel</button>
                    <button type="button" className="btn btn-primary" onClick={this.submitUnAssignCommand.bind(this)}>Save</button>
                    
                </div>
            </div>
        </div>
    }
}
class Customers {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
    children: CustomerAccessGroups[]
}
class CustomerAccessGroups {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
}